import React from 'react';
import ErpTablePage from '../components/ErpTablePage';
import ErpDocPage from '../components/ErpDocPage';

const CustomerReceipts = () => {
  return <ErpDocPage moduleKey="customer_receipts" />;  // ✅ CORRECT
};

export default CustomerReceipts;